/** @format */

import React, { useEffect, useState } from 'react';
import './styles.scss';
// import {
//   // Table,
//   // Button,
//   // InputGroup
// } from 'react-bootstrap';
// import Form from 'react-bootstrap/Form';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {
//   // faXmarkCircle,
//   // faCircleCheck,
//   faSearch
//   // faCopy
// } from '@fortawesome/free-solid-svg-icons';
// import Pagination from '../Pagination';
import { useDispatch, useSelector } from 'react-redux';
import { listAllLeadsRequestedAction } from 'stateContainer/actions';
import moment from 'moment';
// import TableDataLoader from 'components/TableDataLoader';
// import ButtonSyncLoader from 'components/ButtonSyncLoader';
import appConfig from 'config/app';
import StatusIndicator from 'components/StatusIndicator';
// import { DataTable as Table } from 'components/DataTable';
import { DataTable as Table } from 'components/MaterialUiDataTable';
import { ExpandableTableRow as ExpandableRow } from './ExpandableTableRow';
import CustomSearch from './CustomSearch';

// const recordsPerPage = ;

const LEAD_STATUSES = {
  NEW: 'NEW',
  RESPONDED: 'RESPONDED'
};

export default function Leads({
  // eslint-disable-next-line no-empty-pattern
  text: {
    // heading,
    // table: { table_headings }
  }
  // handleCopyLinkToClipBoard
}) {
  // eslint-disable-next-line no-unused-vars
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [leadsSearchText, setLeadsSearchText] = useState(null);
  // const [searchName, setSearchName] = useState('');

  useEffect(() => {
    dispatch(
      listAllLeadsRequestedAction({
        page: currentPage,
        recordsPerPage,
        search: leadsSearchText
      })
    );
  }, [recordsPerPage, currentPage]);

  const allLeadsData = useSelector((state) => state.leads);
  const paginationData = useSelector((state) => state.leads.paging);

  const dispatch = useDispatch();

  const formatDataRow = (dataRow) => {
    return {
      leadType: dataRow.leadType,
      email: dataRow.email,
      location: dataRow.location,
      name: dataRow.name,
      status: dataRow.status,
      createdDatetime: dataRow.createdDatetime
        ? moment(dataRow.createdDatetime).format(
            appConfig.defaultMomentDateTimeFormat
          )
        : '-'
    };
  };

  return (
    <div className='leads-container'>
      <div>
        <Table
          loading={allLeadsData.listRequesting}
          title='Leads'
          className='leads-table'
          columns={[
            {
              label: 'Lead Type',
              name: 'leadType',
              options: {
                customBodyRender: (value) => {
                  return (
                    <div className='lead-type-cell-body'>{value ?? '-'}</div>
                  );
                }
              }
            },
            {
              label: 'Name',
              name: 'name',
              options: {
                draggable: true
              }
            },
            {
              label: 'Email',
              name: 'email'
            },
            {
              label: 'Location',
              name: 'location'
            },
            {
              label: 'Status',
              name: 'status',
              options: {
                customBodyRender: (value) => {
                  return (
                    <StatusIndicator
                      greenStatus={value === LEAD_STATUSES.NEW}
                      greyStatus={value === LEAD_STATUSES.RESPONDED}
                      text={value}
                    />
                  );
                }
              }
            },
            {
              label: 'Received on',
              name: 'createdDatetime'
            }
          ]}
          data={allLeadsData.data.map(formatDataRow)}
          options={{
            serverSide: true,
            draggableColumns: {
              enabled: true
            },
            enableNestedDataAccess: '.',
            expandableRows: true,
            expandableRowsHeader: false,
            expandableRowsOnClick: true,
            pagination: true,
            responsive: 'vertical',
            download: false,
            filter: false,
            print: false,
            renderExpandableRow: (rowData, rowMeta) => (
              <ExpandableRow rowData={rowData} rowMeta={rowMeta} />
            ),
            onChangeRowsPerPage: (numberOfRows) => {
              setRecordsPerPage(numberOfRows);
            },
            onChangePage: (page) => {
              setCurrentPage(page + 1);
            },
            count: paginationData?.totalRecords,
            rowsPerPageOptions: [10, 20, 50, 100],
            customSearchRender: (
              searchText,
              _handleSearch,
              hideSearch,
              currentSearch
            ) => (
              <CustomSearch
                searchText={searchText}
                onSearch={(text) => {
                  setLeadsSearchText(text);
                  dispatch(
                    listAllLeadsRequestedAction({
                      search: text,
                      recordsPerPage
                    })
                  );
                }}
                hideSearch={hideSearch}
                currentSearch={currentSearch}
              />
            )
          }}
        />
      </div>
    </div>
  );
}
